<template>
  <div>
    <b-card header="Default">
      <div slot="header">{{ $lang.addTask }}</div>
      <div class="text-center" v-if="isLoading">
        <b-spinner variant="primary" label="Text Centered"></b-spinner>
      </div>
      <taskForm
        v-if="!isLoading"
        isModal
        @modal-end-up="afterSave"
        @submit="save"
        @responseCode="getResponseCode"
      />
    </b-card>
  </div>
</template>

<script>
import taskForm from "./../forms/taskFrom";
export default {
  components: {
    taskForm,
  },
  name: "add-task",
  inject: ["taskAdminRepository", "attachmentRepository"],
  data() {
    return {
      isLoading: false,
      responseCode: [],
      attachmentId: null,
    };
  },
  methods: {
    afterSave() {
      this.$emit("modal-end-up");
    },
    getResponseCode(code) {
      this.responseCode = code;
    },
    async finalSave() {
      try {
        let payload = {
          data: [],
        };
        let resize_avatar = false;
        for (const item of this.responseCode) {
          if (item.type.match("image")) {
            if (this.keyServies == "person") {
              resize_avatar = true;
            }
          }
          payload.data.push({
            code: item.code,
            resize_avatar: resize_avatar,
            attachment_type_name: "attachment_type_ticket",
          });
        }
        let actionResource = "task";
        let actionkey = this.attachmentId;

        const result = await this.attachmentRepository.create(
          payload,
          actionResource,
          actionkey
        );
        this.$notify.success(result.data.message);
      } catch (error) {
        this.$generateError(error);
      }
    },
    async save(payload) {
      this.isLoading = true;
      try {
        let response = await this.taskAdminRepository.create(payload);
        this.attachmentId = response.data.data.id;

        if (this.attachmentId && this.responseCode.length > 0) {
          await this.finalSave();
        }
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.isLoading = false;
        this.afterSave();
        this.$emit("getData");
      }
    },
  },
};
</script>
